
export default function(store){
  // if onLine not supported, always true
  store.isOnline = navigator.onLine || true;
  window.addEventListener('offline', (e)=> { store.isOnline = false; });
  window.addEventListener('online', (e)=> { store.isOnline = true;  });
}
